import { EventrDate } from '@eventr/common'
import { ColoursObj, TEventrIcons } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useMemo } from 'react'
import { getMinutesFromUnixTimestamp } from '../../../utils'
import { useFormatValue } from '../../hooks/useFormatValue'
import { CardText } from '../subComponents/cardText'
import { ColouredIcon } from '../subComponents/colouredIcon'
import { DisplayLabel } from '../subComponents/displayLabel'

interface IActivityHeaderProps {
    activityName?: string
    visibility?: string
    label?: string
    labelTime?: string
    start?: string
    end?: string
    icon?: string
}

export const ActivityHeader = ({
    activityName,
    visibility,
    label,
    labelTime,
    start,
    end,
    icon,
}: IActivityHeaderProps) => {
    const { formatValue } = useFormatValue()
    const labelOverride = useMemo(() => {
        if (!start || !end) return null
        if (
            getMinutesFromUnixTimestamp(new EventrDate(start).getUnixMs) ===
            getMinutesFromUnixTimestamp(new EventrDate(end).getUnixMs)
        )
            return formatValue(start, 'time')
        return null
    }, [formatValue, start, end])

    return (
        <Stack direction={'row'} justifyContent={'space-between'}>
            <Stack direction={'row'} gap={'8px'}>
                <ColouredIcon
                    name={(icon ?? 'Activity') as TEventrIcons}
                    iconColour={ColoursObj.core.secondary}
                />
                <CardText variant="bodyBold">{activityName}</CardText>
            </Stack>
            <Stack
                alignItems={'center'}
                direction={'row'}
                justifyContent={'flex-start'}
                gap={'8px'}
            >
                {visibility === 'Private' ? (
                    <ColouredIcon height="16px" name={'Private'} />
                ) : (
                    visibility === 'Public' && (
                        <ColouredIcon height="16px" name={'Public'} />
                    )
                )}

                <DisplayLabel
                    label={label}
                    overrideLabel={labelOverride}
                    labelTime={labelTime}
                />
            </Stack>
        </Stack>
    )
}
